/** @format */
import React, { useState, useEffect, useRef } from "react";
import heic2any from "heic2any";
import EXIF from "exif-js";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../css/Report-TH.css";

import { Modal } from "bootstrap";
import html2canvas from "html2canvas";
import { toPng } from "html-to-image";
import * as funcAll from "../../util/funcAll";

import CreateMap from "./CreateMap";
import DropdownOrg from "../menu/DropdownOrg";
import DropdownProblemType from "../menu/DropdownProblemType";
import DropdownWaterLevel from "../menu/DropdownWaterLevel";
import DropdownTimeFlood from "../menu/DropdownTimeFlood";
import PDPA from "../menu/PDPA";

import noImg from "../../assets/no_select.png";
import save from "../../assets/save-icon.png";
import Logo_Traffy from "../../assets/traffy-icon.png";
import Fondue_App_Icon from "../../assets/Fondue_App_Icon.png";
/////////////   Redux  //////////////
import { saveDataLatLon } from "../store/MapPositionSlice";
import { savePageRoute } from "../store/RouteSlice";
import { useSelector, useDispatch } from "react-redux";
import SecureStorage from "react-secure-storage";
import { useLocation, useNavigate } from "react-router-dom";

export default function ReportTH(props) {
  const navigate = useNavigate();
  const globalData = useSelector((state) => ({ ...state }));
  const dispatch = useDispatch();

  const [detailReport, setDetailReport] = useState("");
  const [imgReport, setImgReport] = useState(noImg);

  const [listOrganization, setListOrganization] = useState([]);
  const [selectedOrganization, setSelectedOrganization] = useState(null);

  const [listProblemTypeAll, setListProblemTypeAll] = useState([]);
  const [selectedProblemType, setSelectedProblemType] = useState([]);

  const [listWaterLevel, setListWaterLevel] = useState([]);
  const [selectedWaterLevel, setSelectedWaterLevel] = useState([]);

  const [listTimeFlood, setListTimeFlood] = useState([]);
  const [selectedTimeFlood, setSelectedTimeFlood] = useState([]);

  const inputFile = useRef(null);

  const [alert_header, setAlertHeader] = useState(); //หัวข้อ alert
  const [alert_content, setAlertContent] = useState(); //รายละเอียก alert
  const [alert_description, setAlertDescription] = useState(); //รายละเอียก alert
  const modal_alert_ref = useRef(); //สำหรับ alert
  const [modal_alert_close, setModalAlertClose] = useState(null); //สำหรับ alert

  const modal_loading_ref = useRef();
  const [modal_loading_close, setModalLoadingClose] = useState(null);

  const modal_preview_ref = useRef(); //สำหรับ preview ก่อนแจ้ง
  const [modal_preview_close, setModalPreviewClose] = useState(null); //สำหรับ alert

  const modal_finish_card_ref = useRef(); //สำหรับ finish card หลังแจ้ง
  const [modal_finish_card_close, setModalFinishCardClose] = useState(null); //สำหรับ alert

  const exportRef = useRef(null);
  const shareButton = useRef(null);

  const [phone, setPhone] = useState(null);
  const [otp, setOTP] = useState(null);
  const [showOTP, setShowOTP] = useState(false);
  const [disabledBtnOTP, setDisabledBtnOTP] = useState(false);
  const [verifyOTPStatus, setVerifyOTPStatus] = useState(false);

  const [ip, setIP] = useState("");

  const [resTicketId, setResTicketId] = useState("");
  const [resPassword, setResPassword] = useState("");

  const [previewBtnDisabled, setPreviewBtnDisabled] = useState(false);

  const [update_end, setUpdateEnd] = useState("");
  const [update_enderror, setUpdateEndError] = useState("");

  const [latPhoto, setLatPhoto] = useState(null);
  const [lngPhoto, setLngPhoto] = useState(null);

  const alert_fail = (
    <span class="material-icons text-danger post-alert-icon my-3">cancel</span>
  );
  const alert_warn = (
    <span class="material-icons text-warning post-alert-icon my-3">info</span>
  );

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);

    // getIP();
    navigator.geolocation.getCurrentPosition(showPosition);
  }, []);

  // const getIP = async () => {
  //   funcAll.getIpAddress().then((res) => {
  //     if (res["status"] === "success") {
  //       setIP(res["results"].ip_addr);
  //     } else {
  //     }
  //   });
  // };

  useEffect(() => {
    if (listOrganization.length > 0) {
      let data = listOrganization.filter((item) => item.id === 7315);
      if (data) {
        handleDropdownOrgChange(data[0]);
      }
    }
  }, [listOrganization]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (
        Object.keys(globalData.mapPosition.current_coors).length !== 0 ||
        latPhoto
      ) {
        funcAll
          .getOrg(
            !globalData.mapPosition.current_coors.lat
              ? latPhoto
              : globalData.mapPosition.current_coors.lat,
            !globalData.mapPosition.current_coors.lng
              ? lngPhoto
              : globalData.mapPosition.current_coors.lng,
            "th"
          )
          .then((res) => {
            if (res["status"] === true) {
              setSelectedOrganization(null);
              const newData = res["results"];

              // // --------- 43111 แทรกเป็นอันดับแรก ---------
              // const item43111 = {
              //   id: 43111,
              //   name: "ช่วยน้ำท่วมหาดใหญ่ 2568",
              //   photo:
              //     "https://storage.googleapis.com/traffy_public_bucket/attachment/2025-11/8010317297f762a2ff1825bad3172510.png",
              //   show_in_chatbot: true,
              //   official_group: true,
              // };

              // // กันกรณีมีซ้ำ
              // const exist43111 = newData.findIndex((item) => item.id === 43111);
              // if (exist43111 !== -1) newData.splice(exist43111, 1);

              // // เอาไว้หัวตาราง
              // newData.unshift(item43111);

              // --------- 7315 ขึ้นตามลำดับถัดไป ---------
              const index7315 = newData.findIndex((item) => item.id === 7315);
              if (index7315 !== -1) {
                newData[index7315].name = "กรุงเทพมหานคร";
                const item7315 = newData.splice(index7315, 1)[0];
                newData.splice(1, 0, item7315); // ให้มาเป็นอันดับ 2
              }

              // --------- 39560 แทรก index 2 (อันดับ 3) ---------
              const index39560 = newData.findIndex((item) => item.id === 39560);
              if (index39560 !== -1) {
                const item39560 = newData.splice(index39560, 1)[0];
                newData.splice(2, 0, item39560);
              }

              setListOrganization(newData);
            } else {
              setListOrganization([
                // {
                //   id: 43111,
                //   name: "ช่วยน้ำท่วมหาดใหญ่ 2568",
                //   photo:
                //     "https://storage.googleapis.com/traffy_public_bucket/attachment/2025-11/8010317297f762a2ff1825bad3172510.png",
                //   show_in_chatbot: true,
                //   official_group: true,
                // },
                {
                  id: 7315,
                  name: "กรุงเทพมหานคร",
                  photo:
                    "https://storage.googleapis.com/traffy_public_bucket/attachment/2023-02/f9a8feea6cc86563b8617c1b65a010491e2a987c.jpeg",
                  show_in_chatbot: true,
                  official_group: true,
                  index: 1,
                  index_g: 1,
                  distance: 14515.96,
                  type: ["geo"],
                  post_finish: 586716,
                  post: 736296,
                  admin_staff: 35,
                  fonduegroup_status: "ใช้งานหนัก",
                  last_activity: "11/11/2024",
                },

                {
                  id: 39560,
                  name: "สปคม.",
                  photo:
                    "https://storage.googleapis.com/traffy_public_bucket/attachment/2025-04/e3325208b2a6ae002474b0f00b01b91a4d2f5cb5.png",
                  show_in_chatbot: true,
                  official_group: true,
                },
              ]);
            }
          });
      } else {
        setListOrganization([
          // {
          //   id: 43111,
          //   name: "ช่วยน้ำท่วมหาดใหญ่ 2568",
          //   photo:
          //     "https://storage.googleapis.com/traffy_public_bucket/attachment/2025-11/8010317297f762a2ff1825bad3172510.png",
          //   show_in_chatbot: true,
          //   official_group: true,
          // },
          {
            id: 7315,
            name: "กรุงเทพมหานคร",
            photo:
              "https://storage.googleapis.com/traffy_public_bucket/attachment/2023-02/f9a8feea6cc86563b8617c1b65a010491e2a987c.jpeg",
            show_in_chatbot: true,
            official_group: true,
            index: 1,
            index_g: 1,
            distance: 14515.96,
            type: ["geo"],
            post_finish: 586716,
            post: 736296,
            admin_staff: 35,
            fonduegroup_status: "ใช้งานหนัก",
            last_activity: "11/11/2024",
          },

          {
            id: 39560,
            name: "สปคม.",
            photo:
              "https://storage.googleapis.com/traffy_public_bucket/attachment/2025-04/e3325208b2a6ae002474b0f00b01b91a4d2f5cb5.png",
            show_in_chatbot: true,
            official_group: true,
          },
        ]);
        // setAlert(
        //   "กรุณาอนุญาตให้เข้าถึงตำแหน่ง",
        //   alert_warn,
        //   "เพื่อทราบตำแหน่งปัญหาได้ตรงจุด ระบบต้องขอใช้ตำแหน่งของท่าน"
        // );
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [globalData.mapPosition.current_coors, latPhoto]);

  useEffect(() => {
    if (update_end != undefined && update_end != "") {
      modalHide(modal_loading_close);
      setTimeout(() => {
        modalShow(modal_finish_card_ref, setModalFinishCardClose);
      }, 500);
    }
  }, [update_end]);

  useEffect(() => {
    if (update_enderror != undefined && update_enderror != "") {
      modalHide(modal_loading_close);
    }
  }, [update_enderror]);

  const showPosition = async (position) => {
    let current_coors = {
      lng: position.coords.longitude,
      lat: position.coords.latitude,
    };
    await dispatch(saveDataLatLon(current_coors));
  };

  const handleBtnAlertClose = async () => {
    modalHide(modal_alert_close);
  };

  const handlePreviewClose = async () => {
    modalHide(modal_preview_close);
  };

  const handleFinishCardClose = async (ticket, pass, exportElement) => {
    DownloadTicketCard(ticket, pass, exportElement);
  };

  const modalShow = (mRef, setModals) => {
    const modal = new Modal(mRef.current, { keyboard: false });
    setModals(modal);
    modal.show();
  };

  const modalHide = (modal_hide) => {
    modal_hide.hide();
  };

  function handleDropdownOrgChange(selected) {
    setSelectedOrganization(selected);
  }

  const onChangePicture = async (e) => {
    const file = e.target.files[0];

    if (file) {
      const fileName = file.name;
      const fileExtension = fileName.split(".").pop().toLowerCase(); // แยกนามสกุลออกมาเป็นตัวพิมพ์เล็ก
      // console.log("File Extension:", fileExtension); // แสดงนามสกุลไฟล์ใน console

      try {
        // ตรวจสอบว่าเป็นไฟล์ HEIC
        if (fileExtension === "heic" || fileExtension === "heif") {
          const convertedBlob = await heic2any({
            blob: file,
            toType: "image/jpeg",
            quality: 0.7,
          });

          // อ่านข้อมูลจากไฟล์ที่แปลงแล้ว
          const reader = new FileReader();
          reader.onload = () => {
            if (reader.result) {
              // console.log(reader.result);
              setImgReport(reader.result); // ตั้งค่าภาพที่แปลงเพื่อแสดง
              processImage(reader.result); // ประมวลผลภาพ
            } else {
              console.error("Reader result is empty");
            }
          };
          reader.readAsDataURL(convertedBlob); // อ่านไฟล์ที่แปลงแล้ว
        } else {
          // ถ้าไม่ใช่ไฟล์ HEIC ก็อ่านไฟล์ปกติ
          const reader = new FileReader();
          reader.onload = () => {
            if (reader.result) {
              setImgReport(reader.result); // ตั้งค่าภาพ
              processImage(reader.result); // ประมวลผลภาพ
            } else {
              console.error("Reader result is empty");
            }
          };
          reader.readAsDataURL(file);
        }
      } catch (error) {
        console.error("Error converting HEIC file:", error);
      }
    }
  };

  // ฟังก์ชันประมวลผลภาพ
  const processImage = (imageSrc) => {
    const img = new Image();
    img.src = imageSrc;
    img.onload = () => {
      EXIF.getData(img, function () {
        const exifData = EXIF.getAllTags(this);
        // console.log("EXIF Data:", exifData);

        // ดึงข้อมูล GPS latitude และ longitude
        const lat = EXIF.getTag(this, "GPSLatitude");
        const lng = EXIF.getTag(this, "GPSLongitude");
        const latRef = EXIF.getTag(this, "GPSLatitudeRef");
        const lngRef = EXIF.getTag(this, "GPSLongitudeRef");

        if (lat && lng) {
          const latitude = convertDMSToDD(lat[0], lat[1], lat[2], latRef);
          const longitude = convertDMSToDD(lng[0], lng[1], lng[2], lngRef);
          console.log(latitude);
          console.log(longitude);

          setLatPhoto(latitude);
          setLngPhoto(longitude);
        } else {
          console.log("No GPS data available");
        }
      });
    };
  };

  const convertDMSToDD = (degrees, minutes, seconds, direction) => {
    let dd = degrees + minutes / 60 + seconds / 3600;
    if (direction === "S" || direction === "W") {
      dd = dd * -1;
    }
    return dd;
  };

  const handleClickUploadImg = (event) => {
    if (inputFile.current) {
      inputFile.current.click();
    } else {
      console.error("inputFile.current is null");
    }
  };

  const setAlert = async (header_text, icon, description) => {
    setAlertHeader(header_text);
    setAlertContent(icon);
    setAlertDescription(description);
    modalShow(modal_alert_ref, setModalAlertClose);
  };

  const view_Finish_Card = (e) => {
    setPreviewBtnDisabled(false);
    // modalHide(modal_preview_close);
    setTimeout(() => {
      modalShow(modal_loading_ref, setModalLoadingClose);
    }, 500);

    funcAll
      .sendDataEN(
        detailReport,
        imgReport,
        latPhoto ? latPhoto : globalData.mapPosition.current_coors.lat,
        lngPhoto ? lngPhoto : globalData.mapPosition.current_coors.lng,
        "th",
        selectedOrganization["id"],
        phone
      )
      .then((res) => {
        if (res["status"] === "success") {
          setTimeout(() => {
            setUpdateEnd(Date.now());
          }, 500);
          setResTicketId(res["results"].ticket_id);
          setResPassword(res["results"].password);
          let authorize = {
            ticket_report: res["results"].ticket_id,
            password_report: res["results"].password,
          };
          SecureStorage.setItem("authorization", authorize);
        } else if (res["status"] === "fail") {
          setTimeout(() => {
            setUpdateEndError(Date.now());
          }, 500);

          setTimeout(() => {
            setAlert("Fail", alert_fail, res["message"]);
          }, 1500);
        }
      });
  };

  const DownloadTicketCard = (ticket, pass, domElement) => {
    if (domElement === null) {
      return;
    }

    toPng(domElement)
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = "myCase.png";
        link.click();

        modalHide(modal_finish_card_close);
        let authorize = {
          ticket_report: ticket,
          password_report: pass,
        };

        sessionStorage.setItem("authorization", JSON.stringify(authorize));

        setTimeout(() => {
          navigate("/track");
        }, 1000);
      })
      .catch((err) => {
        console.log("Error while generating image:", err);
        modalHide(modal_finish_card_close);
        let authorize = {
          ticket_report: ticket,
          password_report: pass,
        };

        sessionStorage.setItem("authorization", JSON.stringify(authorize));

        setTimeout(() => {
          navigate("/track");
        }, 1000);
      });
  };

  const getOTP = async () => {
    setDisabledBtnOTP(true);
    funcAll.getOTP(phone).then((res) => {
      if (res["status"] == true) {
        setShowOTP(true);
        setDisabledBtnOTP(false);
      } else {
        setShowOTP(false);
        setDisabledBtnOTP(false);
        setAlert("ผิดพลาด", alert_fail, res["message"]);
      }
    });
  };

  const verifyOTP = async () => {
    setDisabledBtnOTP(true);
    funcAll.verifyOTP(phone, otp).then((res) => {
      if (res["status"] == true) {
        setShowOTP(true);
        setVerifyOTPStatus(true);
        setAlert("สำเร็จ", alert_warn, "ยืนยัน OTP สำเร็จ");
      } else {
        // setVerifyOTPStatus(false);
        setDisabledBtnOTP(false);
        // setShowOTP(false);
        setAlert("ผิดพลาด", alert_fail, res["message"]);
      }
    });
  };

  const view_Preview = (e) => {
    if (detailReport.length < 1) {
      setTimeout(() => {
        setAlert("ผิดพลาด", alert_fail, "กรุณากรอกรายละเอียดปัญหา");
      }, 1000);
    } else if (detailReport.length >= 1 && detailReport.length < 5) {
      setTimeout(() => {
        setAlert("ผิดพลาด", alert_fail, "รายละเอียดของปัญหา สั้นเกินไป");
      }, 1000);
    } else if (imgReport == noImg) {
      setAlert("ผิดพลาด", alert_fail, "กรุณาแนบภาพปัญหา");
    } else {
      if (phone) {
        if (!verifyOTPStatus) {
          setAlert("ผิดพลาด", alert_fail, "กรุณายืนยัน OTP ก่อน");
        } else {
          view_Finish_Card();
        }
      } else {
        view_Finish_Card();
      }
    }
  };

  return (
    <>
      <div className="container-reportDesktop">
        {/* <div className="ip-address">
          <p>{ip}</p>
        </div> */}
        <span>
          <p className="title">รายละเอียดการแจ้ง</p>
          <p className="star">*</p>
        </span>
        <div className="container-detail-img">
          <textarea
            required
            type="text"
            minLength={5}
            value={detailReport}
            onChange={(e) => setDetailReport(e.target.value)}
            placeholder="‘พิมพ์บอกเล่าปัญหา’ อธิบายเกี่ยวกับปัญหาที่คุณต้องการแจ้ง หรือเสนอทางแก้ไขได้เลย"
          />

          <div
            className="area-img-report-desktop"
            onClick={() => handleClickUploadImg()}>
            <img
              className={`img-report ${imgReport !== noImg ? "have-img" : ""}`}
              src={imgReport}
            />
            <input
              type="file"
              id="file"
              required
              onChange={onChangePicture}
              ref={inputFile}
              accept="image/*"
              style={{ display: "none" }}
            />

            {imgReport === noImg ? (
              <>
                <span>
                  <p className="titleMd" style={{ color: "#34b70d" }}>
                    แนบรูปภาพปัญหา คลิกที่นี่
                  </p>
                </span>
              </>
            ) : null}
          </div>
        </div>

        <div
          style={{
            display: "flex",
            gap: "1rem",
            alignItems: "end",
            width: "100%",
          }}>
          <div
            style={{ display: "flex", flexDirection: "column", width: "100%" }}>
            <span style={{ marginTop: "0.5rem" }}>
              <p className="title">หน่วยงานที่ต้องการแจ้งเรื่อง</p>
              <p className="star">*</p>
            </span>

            <DropdownOrg
              options={listOrganization}
              onSelect={(select) => handleDropdownOrgChange(select)}
              selectedOption={selectedOrganization}
              placeholder="Select the Responsible Agency"
            />
          </div>

          {!showOTP ? (
            <div
              style={{
                display: "flex",
                width: "100%",
                alignItems: "end",
                gap: "0.5rem",
              }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}>
                <span
                  style={{
                    marginTop: "0.5rem",
                  }}>
                  <p className="title">เบอร์มือถือ</p>
                </span>

                <input
                  key="phone-input"
                  style={{ padding: "0.5rem" }}
                  className="form-control shadow-style input"
                  maxLength={10}
                  pattern="\d*"
                  inputMode="numeric"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
                  placeholder="หากต้องการรับ SMS ดูความคืบหน้าการแจ้ง"
                />
              </div>
              <button
                className="btn-get-otp"
                style={{
                  height: "40px",
                  width: "100px",
                  border: "1px solid #000",
                  borderRadius: "8px",
                }}
                onClick={() => getOTP()}
                disabled={disabledBtnOTP}>
                <p>รับ OTP</p>
              </button>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                width: "100%",
                alignItems: "end",
                gap: "0.5rem",
              }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}>
                <span
                  style={{
                    marginTop: "0.5rem",
                  }}>
                  <p className="title">OTP</p>
                </span>

                <input
                  key="otp-input"
                  style={{ padding: "0.5rem" }}
                  className="form-control shadow-style input"
                  maxLength={4}
                  pattern="\d*"
                  inputMode="numeric"
                  value={otp}
                  onChange={(e) => setOTP(e.target.value.replace(/\D/g, ""))}
                  placeholder="กรอก OTP ที่ได้รับทาง SMS"
                />
              </div>
              <button
                className="btn-get-otp"
                style={{
                  height: "40px",
                  width: "100px",
                  border: "1px solid #000",
                  borderRadius: "8px",
                }}
                onClick={() => verifyOTP()}
                disabled={disabledBtnOTP}>
                <p>ยืนยัน</p>
              </button>
            </div>
          )}
        </div>

        <div>
          {Object.keys(globalData.mapPosition.current_coors).length !== 0 ||
          latPhoto ? (
            <>
              <span style={{ marginTop: "0.5rem" }}>
                <p className="title">ตำแหน่งของปัญหา</p>
              </span>
              <CreateMap latPhoto={latPhoto} lngPhoto={lngPhoto} />
            </>
          ) : null}

          <button
            className="btn-report"
            style={{ marginTop: "2rem" }}
            onClick={view_Preview}>
            <p>แจ้งเรื่องใหม่</p>
          </button>

          <PDPA />
        </div>
      </div>

      {/* ******* ส่วนของ Alert ************* */}
      <div
        className="modal fade"
        ref={modal_alert_ref}
        id="stateUpdate"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content bg-transparent border-0">
            <div className="modal-body text-center">
              <div className="d-flex justify-content-center">
                <div className="card post-alert-box rounded-4">
                  <div className="card-body">
                    <p className="card-text p-0 m-0">{alert_content}</p>
                    <h4 className="txt-title-alert">{alert_header}</h4>
                    <h6 className="txt-detail-alert">{alert_description}</h6>
                    <button
                      type="button"
                      className="btn-alert"
                      onClick={handleBtnAlertClose}>
                      <p>ตกลง</p>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ******* ส่วนของ Alert ************* */}

      {/* กำลังดำเนินการแจ้งเรื่อง */}
      <div
        className="modal fade"
        ref={modal_loading_ref}
        id="loadingReport"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content bg-transparent border-0">
            <div className="modal-body text-center">
              <div className="d-flex justify-content-center">
                <span className="spinner-border text-white" role="status">
                  <span className="visually-hidden">Loading...</span>
                </span>
                <h4 className="text-white ps-2">กำลังดำเนินการ...</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* กำลังดำเนินการแจ้งเรื่อง */}

      {/* ******* ส่วนของ popup preview ************* */}
      <div class="modal fade" ref={modal_preview_ref}>
        <div class="modal-dialog modal-dialog-centered modal-dialog-custom">
          <div class="modal-content">
            <div className="modal-body text-center p-0">
              <p className="title-preview mt-3">ตัวอย่างการแจ้ง</p>
            </div>

            <div class="container-detail-preview2">
              <div className="container-sub-detail-preview mt-3">
                <p className="sub-title">เลือกประเภทปัญหา</p>
                {selectedProblemType.length != 0 ? (
                  <>
                    {" "}
                    <p className="sub-title-detail">
                      {selectedProblemType["problem_types"][0]["name"] !=
                      "น้ำท่วม"
                        ? selectedProblemType["problem_types"][0]["name"]
                        : selectedProblemType["problem_types"][0]["name"] +
                          " - " +
                          selectedWaterLevel.name +
                          " - " +
                          selectedTimeFlood.name}
                    </p>
                  </>
                ) : null}
              </div>

              <div className="container-sub-detail-preview mt-2">
                <p className="sub-title">รายละเอียด</p>
                <p className="sub-title-detail">{detailReport}</p>
              </div>

              <div className="container-sub-detail-preview mt-2">
                <p className="sub-title">หน่วยงานรับเรื่อง</p>
                <p className="sub-title-detail">
                  {selectedOrganization ? selectedOrganization.name : null}
                </p>
              </div>

              <div className="container-preview-img-report mt-2">
                <p>รูปภาพปัญหา</p>
                <img src={imgReport}></img>
              </div>

              <div className="container-btn-preview mt-3">
                <a className="btn-cancel" onClick={handlePreviewClose}>
                  <p>ย้อนกลับ</p>
                </a>

                <button
                  className="btn-report"
                  onClick={view_Finish_Card}
                  disabled={previewBtnDisabled}>
                  <p>แจ้งเรื่องใหม่</p>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ******* ส่วนของ popup preview ************* */}

      {/* ******* ส่วนของ popup finish card ************* */}
      <div class="modal fade" ref={modal_finish_card_ref}>
        <div class="modal-dialog modal-dialog-centered modal-dialog-custom">
          <div class="modal-content modal-content-finish-card">
            <div className="parent" ref={exportRef} id="finish-card">
              <div class="container-detail-finish-card2">
                <div className="container-preview-img-report mt-2">
                  <img src={imgReport}></img>
                </div>

                <div
                  style={{
                    width: "100%",
                    height: "auto",
                    padding: "0.2rem 0.5rem",
                    backgroundColor: "#E6E0E9",
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.1rem",
                    borderBottom: "2px solid #65558F",
                    marginTop: "0.5rem",
                  }}>
                  <p style={{ fontSize: "13px" }}>Ticket ID</p>
                  <p style={{ fontWeight: "600" }}>{resTicketId}</p>
                </div>
                <div
                  style={{
                    width: "100%",
                    height: "auto",
                    padding: "0.2rem 0.5rem",
                    backgroundColor: "#E6E0E9",
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.1rem",
                    borderBottom: "2px solid #65558F",
                    marginTop: "0.5rem",
                  }}>
                  <p style={{ fontSize: "13px" }}>Pin</p>
                  <p style={{ fontWeight: "600" }}>{resPassword}</p>
                </div>
                <div
                  style={{
                    width: "100%",
                    height: "auto",
                    padding: "0.5rem 1rem",
                    backgroundColor: "#FEF7FF",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "0.5rem",
                  }}>
                  <p
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#e32715",
                    }}>
                    โปรดบันทึกภาพนี้ไว้
                    เพื่อใช้ติดตามความคืบหน้าของเรื่องที่แจ้ง
                  </p>
                </div>
              </div>
            </div>

            <div
              className="container-btn-finish-card"
              style={{ marginTop: "0.5rem" }}>
              <div
                className="btn-finish-card"
                onClick={() =>
                  handleFinishCardClose(
                    resTicketId,
                    resPassword,
                    exportRef.current
                  )
                }>
                <p>บันทึกแล้ว, ดูความก้าวหน้า</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
